"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkStyle = exports.getLinkSize = exports.getButtonStyle = exports.getButtonSize = exports.actionFormatter = void 0;
/**
 * Function for button action style
 * @function actionFormatter
 * @param { object } action - returns an object with the appropriate actionType and style attributes
 */
const actionFormatter = (data, methods) => {
  const {
    /* ActionGroup props */
    action,
    fullyClickableParent,
    isKnockoutLink,
    textForScreenReaders,
    // used when a component is fully clickable. If false will add a tab-index = -1 to avoid duplicate links for ADA
    /* ActionGroupDefault props */
    derivedAriaLabel,
    style,
    size,
    /* ActionGroupMulti props */
    hasOneAction,
    index,
    types
  } = data;
  const {
    getButtonMarkup,
    getLinkMarkup
  } = methods;

  /* ActionGroupMulti stylings */
  let {
    buttonStyle,
    linkStyle
  } = data;
  const isValidAction = !action.url || !action.href || !action.graphql;
  if (!isValidAction) {
    return null;
  }
  const isLink = !!action.url || !!action.anchorId || !!action.href;

  /* ActionGroupMulti stylings */
  const buttonAsLink = !isLink && types === 'link';
  const linkAsButton = isLink && types === 'button';

  /* ActionGroupDefault stylings */
  let actionStyle = '';
  let actionSize = '';

  /* Link or Button styling to send back */
  let formattedAction = {};

  /**
    Checks if action is a button as a link and
    sets style accordingly if so.
  */
  if (buttonAsLink) {
    buttonStyle = {
      variant: 'link',
      size: 'compact'
    };
  }

  /**
    Checks if action is a link as a button and
    sets style accordingly if so.
  */
  if (linkAsButton) {
    linkStyle = {
      variant: 'buttonSecondary',
      size: 'tiny'
    };
  }
  if (isLink) {
    actionStyle = getLinkStyle(style);
    actionSize = getLinkSize(size);
    formattedAction = getLinkMarkup({
      action,
      actionStyle,
      actionSize,
      derivedAriaLabel,
      fullyClickableParent,
      hasOneAction,
      index,
      isKnockoutLink,
      textForScreenReaders,
      linkStyle
    });
  } else {
    actionStyle = getButtonStyle(style);
    actionSize = getButtonSize(size);
    formattedAction = getButtonMarkup({
      action,
      actionStyle,
      actionSize,
      buttonStyle,
      derivedAriaLabel,
      fullyClickableParent,
      hasOneAction,
      index,
      isKnockoutLink,
      textForScreenReaders
    });
  }
  return formattedAction;
};

/**
 * Function for button action style
 * @function getButtonStyle
 * @param { string } style - returns the string to be passed as the variant in button
 */
exports.actionFormatter = actionFormatter;
const getButtonStyle = style => {
  switch (style) {
    case 'Primary Button':
      return 'primary';
    case 'Secondary Button':
      return 'secondary';
    case 'Tertiary Button':
      return 'tertiary';
    case 'Primary Inverse Button':
      return 'primaryInverse';
    case 'Primary Link':
      return 'link';
    case 'Arrow Link':
      return 'linkArrow';
    case 'AI Button':
      return 'ai';
  }
};

/**
 * Function for button action size
 * @function getButtonSize
 * @param { string } size - returns the size to be passed as the size in button
 */
exports.getButtonStyle = getButtonStyle;
const getButtonSize = size => {
  switch (size) {
    case 'default':
      return 'compact';
    case 'compact':
      return 'tiny';
    case 'oversized':
      return 'default';
    default:
      return 'compact';
  }
};

/**
 * Function for link action size
 * @function getLinkSize
 * @param { string } size - returns the size to be passed as the size in link
 */
exports.getButtonSize = getButtonSize;
const getLinkSize = size => {
  switch (size) {
    case 'default':
      return 'default';
    case 'compact':
      return 'compact';
    case 'oversized':
      return 'oversized';
    default:
      return 'default';
  }
};

/**
 * Function for button action style
 * @function getLinkStyle
 * @param { string } style - returns the string to be passed as the variant in button
 */
exports.getLinkSize = getLinkSize;
const getLinkStyle = style => {
  switch (style) {
    case 'Primary Link':
      return 'primary';
    case 'Primary Button':
      return 'buttonPrimary';
    case 'Secondary Button':
      return 'buttonSecondary';
    case 'Primary Inverse Button':
      return 'buttonPrimaryInverse';
    case 'Tertiary Button':
      return 'buttonTertiary';
    case 'AI Button':
      return 'buttonAi';
    case 'Arrow Link':
      return 'arrow';
  }
};
exports.getLinkStyle = getLinkStyle;